export const validateCategories = categoryRequiredMessage => ({
  value: value => !!(value && value.length > 0),
  message: categoryRequiredMessage,
});

export const validatePrice = priceMustBePositiveMessage => ({
  value: value => {
    if (!value) return true;
    if (parseFloat(value) <= 0) return false;
    return true;
  },
  message: priceMustBePositiveMessage,
});
